// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import 'owl.carousel';

Rails.start()
Turbolinks.start()
ActiveStorage.start()



$(function(){
  $(".owl-carousel").owlCarousel({
    items:4,
    autoWidth:true,
    loop:true,
    margin:10,
    autoplay:true,
    autoplayTimeout:2000,
    autoplayHoverPause:true,
    navigation:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        900:{
            items:2,
            nav:true
        },
        1200:{
            items:3,
            nav:true,
            loop:false
        }
    }
 
  });
})